module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f6d5d81"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/columngroup/ColumnGroup.vue
// module id = 2224
// module chunks = 0